import { ChangeEvent, FunctionComponent, useState } from 'react';
import classnames from 'classnames';

import InputWrapper, { ValidationActions } from 'components/layout/forms/InputWrapper';

import { Props } from './index';
import StyledComponent from './styles';

const LayoutFormsInput: FunctionComponent<Props> = ({
    className,
    name,
    label,
    helper,
    value,
    onChange,
    style,
    styles,
    disabled,
    validationAction,
    decoratorLeft,
    decoratorRight,
    expandable,
    error,
    required,
    disableDefaultRequiredBehaviour = false,
}) => {
    const errorMessage = error;
    const [currentLabel, setCurrentLabel] = useState<string>(label);

    return (
        <StyledComponent
            className={classnames(
                'layout-forms-checkbox',
                className,
                [`style-${style}`],
                {
                    'error': Boolean(errorMessage),
                    'decorator-left': Boolean(
                        errorMessage && validationAction === ValidationActions.Decorator ||
                        decoratorLeft && decoratorLeft.visible !== false
                    ),
                    'decorator-right': Boolean(decoratorRight && decoratorRight.visible !== false),
                    'disabled': disabled,
                }
            )}
            style={styles}
        >
            <InputWrapper
                name={name}
                helper={helper}
                error={errorMessage}
                validationAction={ValidationActions.None}
                decoratorLeft={decoratorLeft.visible !== false && decoratorLeft}
                decoratorRight={decoratorRight.visible !== false && decoratorRight}
            >
                <label
                    htmlFor={name}
                    className="checkbox-wrapper"
                >
                    <input
                        id={name}
                        name={name}
                        className="checkbox"
                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                            onChange(e);
                        }}
                        type="checkbox"
                        value={value}
                        checked={Boolean(value)}
                        disabled={disabled}
                        required={disableDefaultRequiredBehaviour ? false : required}
                    />
                    <span className="checkbox-trigger" />
                </label>
                <span className="label">
                    <span dangerouslySetInnerHTML={{ __html: currentLabel || label }} />
                    {expandable?.enabled && currentLabel !== expandable.label && (
                        <span
                            className="expand-trigger"
                            onClick={() => setCurrentLabel(expandable.label)}
                        >
                            {expandable.triggerText || 'Rozwiń'}
                        </span>
                    )}
                </span>
            </InputWrapper>
            {errorMessage && required && (
                <div className="error-container">
                    <div
                        className="error-message"
                        dangerouslySetInnerHTML={{ __html: errorMessage }}
                    />
                </div>
            )}
        </StyledComponent>
    );
};

export default LayoutFormsInput;
